var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseRoundBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(-6435 -9709)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 24,
    height: 24,
    transform: "translate(6435 9709)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(6435 9709)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M6443.314,9725.4a.718.718,0,0,1-.507-1.227l7.371-7.372a.718.718,0,0,1,1.015,1.017l-7.371,7.372A.716.716,0,0,1,6443.314,9725.4Z",
    fill: "#8a8fb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M6450.685,9725.4a.716.716,0,0,1-.507-.21l-7.371-7.372a.718.718,0,0,1,1.015-1.017l7.371,7.372a.718.718,0,0,1-.508,1.227Z",
    fill: "#8a8fb5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRoundBg);
export default __webpack_public_path__ + "static/media/icon-close-round-bg.2b615c1eaf09379462470102f35eca9e.svg";
export { ForwardRef as ReactComponent };